import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function InfoPage({ title, seoTitle, description, children }) {
  const tabTitle = seoTitle || title;
  return (
    <div style={{ background: "#000", color: "#eee", minHeight: "100vh", padding: "24px 16px" }}>
      <Helmet>
        <title>{tabTitle ? `${tabTitle} — Trescend` : "Trescend"}</title>
        {description && <meta name="description" content={description} />}
      </Helmet>

      <div style={{ maxWidth: 800, margin: "0 auto", lineHeight: 1.7 }}>
        <Link to="/" style={{ color: "#f5c542" }}>← Back to home</Link>
        {title && <h1>{title}</h1>}
        {children}
      </div>
    </div>
  );
}
